import { Injectable } from '@angular/core';
import { IAuthStrategy } from './auth-strategy.interface';
import { StandardAuthStrategy } from './standard-auth.strategy';
import { GoogleAuthStrategy } from './google-auth.strategy';
import { AuthType } from '../../models/auth.models';
import { LoggerService } from '../logger.service';

/**
 * Factory para crear estrategias de autenticación
 * Implementa el patrón Factory (SOLID - Open/Closed Principle)
 */
@Injectable({
    providedIn: 'root'
})
export class AuthStrategyFactory {
    constructor(
        private standardAuthStrategy: StandardAuthStrategy,
        private googleAuthStrategy: GoogleAuthStrategy,
        private logger: LoggerService
    ) {}

    /**
     * Crea la estrategia de autenticación apropiada según el tipo
     * @param authType - Tipo de autenticación
     * @returns Estrategia de autenticación correspondiente
     */
    createStrategy(authType: AuthType): IAuthStrategy {
        switch (authType) {
            case AuthType.STANDARD:
                return this.standardAuthStrategy;
            
            case AuthType.GOOGLE:
                return this.googleAuthStrategy;
            
            default:
                return this.standardAuthStrategy;
        }
    }
}
